export const LOG_IN = 'auth/LOG_IN';
export const LOG_OUT = 'auth/LOG_OUT';
export const UPDATE_TOKEN = 'auth/UPDATE_TOKEN';
export const REGISTER = 'auth/REGISTER';
export const FORGOTTEN_PASSWORD = 'auth/FORGOTTEN_PASSWORD';
export const RESET_PASSWORD_CONFIRM = 'auth/RESET_PASSWORD_CONFIRM';
export const CHANGE_PASSWORD = 'auth/CHANGE_PASSWORD';
export const CHANGE_EMAIL = 'auth/CHANGE_EMAIL';
export const REFRESH_ACCOUNT_DATA = 'auth/REFRESH_ACCOUNT_DATA';
